/*
 *
 * OperationLoyalty
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 24-Jul-2025
 */

import { connect } from 'react-redux'
import OperationLoyalty from './OperationLoyalty'

const mapDispatchToProps = {}

const mapStateToProps = (state) => ({
  info: state.operations?.operation?.additionalData || null,
  isLoading: state.loading.local_OperationDetails || false,
  currency: state?.operations?.operation?.operationCurrency || null
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(OperationLoyalty)
